import { useSuspenseQuery } from '@tanstack/react-query';

import * as analytics from '@gitbook/app-analytics/client';
import { Button, DialogTrigger, type OverlayTriggerState } from '@gitbook/spine-react';

import { apiQuery } from '../../state';

/**
 * Button to add an OpenAPI spec.
 */
export function OpenAPIAddSpecButton(props: {
    organizationId: string;
    trigger: OverlayTriggerState;
    analyticsContext: analytics.OpenAPIAnalyticsCreateContext;
}) {
    const { organizationId, trigger, analyticsContext } = props;
    const { data: organization } = useSuspenseQuery(
        apiQuery('getOrganizationById', { organizationId })
    );
    const buttonProps = { label: 'Add specification' };
    if (!organization.permissions.createOpenAPISpec) {
        return (
            <Button
                {...buttonProps}
                disabled
                tooltip={{
                    label: "You do not have permission to add a specification. Reach out to your organization's admin to get started.",
                }}
            />
        );
    }
    return (
        <DialogTrigger trigger={trigger}>
            <Button
                {...buttonProps}
                onPress={() => {
                    analytics.logEvent({
                        type: 'openapi_spec_create_intent',
                        organization: organizationId,
                        trigger: 'empty-state-action',
                        ...analyticsContext,
                    });
                }}
            />
        </DialogTrigger>
    );
}
